export default "__VITE_PUBLIC_ASSET__1064ca4c__"